import script from "./StepBullets.vue?vue&type=script&setup=true&lang=js"
export * from "./StepBullets.vue?vue&type=script&setup=true&lang=js"

import "./StepBullets.vue?vue&type=style&index=0&id=6e941c63&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e941c63"]])

export default __exports__